module.exports = __webpack_public_path__ + "static/sass-343d0f266f4ff6d04f31af4a7d817fb0.png";